export const runTimeDataList = [
    {
        name:     'alldays',
        selected: false,
        timeList: [
            {
                from: '',
                to:   '',
                id:   0
            }
        ]
    },
    {
        name:     'sunday',
        selected: false,
        timeList: [
            {
                from: '',
                to:   '',
                id:   0
            }
        ]
    },
    {
        name:     'monday',
        selected: false,
        timeList: [
            {
                from: '',
                to:   '',
                id:   0
            }
        ]
    },
    {
        name:     'tuesday',
        selected: false,
        timeList: [
            {
                from: '',
                to:   '',
                id:   0
            }
        ]
    },
    {
        name:     'wednesday',
        selected: false,
        timeList: [
            {
                from: '',
                to:   '',
                id:   0
            }
        ]
    },
    {
        name:     'thursday',
        selected: false,
        timeList: [
            {
                from: '',
                to:   '',
                id:   0
            }
        ]
    },
    {
        name:     'friday',
        selected: false,
        timeList: [
            {
                from: '',
                to:   '',
                id:   0
            }
        ]
    },
    {
        name:     'saturday',
        selected: false,
        timeList: [
            {
                from: '',
                to:   '',
                id:   0
            }
        ]
    }
];
